module.exports = __webpack_public_path__ + "assets/img/f5ec8b640babb563c833921c582c1158.svg";